import axios from "axios";

export const getUsersBySchoolRole = async ({
  schoolRoleId,
  page,
  size,
  search,
  schoolId
}) => {
  try {

    let url = (search && search !== null) 
    ? `/api/v1/user/schoolrole?roleId=${schoolRoleId}&search=${search}&page=${page}&size=${size}&schoolId=${schoolId}` 
    : `/api/v1/user/schoolrole?roleId=${schoolRoleId}&page=${page}&size=${size}&schoolId=${schoolId}` ;
    return await axios.get(url);
  } catch (error) {
    throw error;
  }
};

export const addUser = async ({
  email,
  phone,
  firstName,
  lastName,
  schoolId,
  roles,
  gender,
  address1,
  address2,
  state,
  sendInvite,
  uploadFile
}) => {
  try {
    return await axios.post("/api/v1/user", {
      email: email,
      phone: phone,
      firstName: firstName,
      lastName: lastName,
      schoolId: schoolId,
      role: roles,
      gender: gender,
      address1: address1,
      address2: address2,
      state: state,
      sendInvite: sendInvite,
      uploadFile: uploadFile
    });
  } catch (error) {
    throw error;
  }
};

export const editUser = async ({
  email,
  password,
  confirmPassword,
  phoneNumber,
  firstName,
  lastName,
  schoolId,
  role
}) => {
  try {
    return await axios.post("/api/v1/user/adduser", {
      email,
      password,
      confirmPassword,
      phoneNumber,
      firstName,
      lastName,
      schoolId,
      role
    });
  } catch (error) {
    throw error;
  }
};

export const deleteUser = async (id) => {
  try {
    return await axios.delete(`/api/v1/user?id=${id}`);
  } catch (error) {
    throw error;
  }
};

export const deleteUsers = async (data) => {
  try {
    return await axios.post("/api/v1/user/delete", data);
  } catch (error) {
    throw error;
  }
};

export const inviteUser = async (username) => {
  try {
    return await axios.post(`/api/v1/user/invite?username=${username}`);
  } catch (error) {
    throw error;
  }
};

export const inviteUsers = async (data) => {
  try {
    return await axios.post("/api/v1/user/invites", data);
  } catch (error) {
    throw error;
  }
};

export const uploadUsers = async ({
  file,
  schoolId,
  role,
  createBy
}) => {
  try {
    
    let fd = new FormData();
    fd.append('file', file);
    fd.append('schoolId', schoolId);
    fd.append('role', role);
    fd.append('createdBy', createBy);

    return await axios.post("/api/v1/user/upload", fd,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  } catch (error) {
    throw error;
  }
};


